import {
  Col,
  ColType,
  Crud,
  CrudAction,
  CrudApi,
  optionOf,
} from "../../comp/crud";
import { ApiClient } from "../../api/ApiClient";
import "../clientConfig/index.scss";
import { Tabs, TabPane, Modal, Form, Toast } from "@douyinfe/semi-ui";
import {
  IconFixedStroked,
  IconModalStroked,
  IconSetting,
} from "@douyinfe/semi-icons";
import { useState } from "react";
import { FormApi } from "@douyinfe/semi-ui/lib/es/form";

let apiClient = ApiClient.getDefault();
let cols: Col[] = [
  {
    name: "名称",
    key: "name",
    type: ColType.STRING,
    showInFilter: true,
    width: 250,
  },
  {
    name: "Code",
    key: "code",
    type: ColType.STRING,
    showInFilter: true,
    width: 250,
  },
  {
    name: "客户端",
    key: "client",
    type: ColType.STRING,
    hideInList: true,
  },
  {
    name: "说明",
    key: "remark",
    type: ColType.TEXT,
    optional: true,
    disabled: true,
    hideInList: true,
    hideInCreate: true,
    hideInEdit: false,
    textRows: 2,
  },
  {
    name: "值",
    key: "value",
    type: ColType.TEXT,
    textRows: 20,
  },
];

let colSyss: Col[] = [
  {
    name: "名称",
    key: "name",
    type: ColType.STRING,
    showInFilter: true,
    width: 250,
  },
  {
    name: "Code",
    key: "code",
    type: ColType.STRING,
    showInFilter: true,
    width: 250,
  },
  {
    name: "客户端",
    key: "client",
    type: ColType.STRING,
    hideInList: true,
  },
  {
    name: "值",
    key: "value",
    type: ColType.TEXT,
    textRows: 20,
  },
];
export default function Config() {
  const [showPublicKeyModal, setShowPublicKeyModal] = useState(false);
  const [createPublicKey, setCreatePublicKey] = useState(false);
  const [publicKeyContent, setPublicKeyContent] = useState('');
  const [publicKeyFormApi, setPublicKeyFormApi] = useState(
    undefined as undefined | FormApi
  );
  const [crudApi, setCrudApi] = useState(undefined as undefined | CrudApi);

  const handlePublicModalClick = async () => {
    try {
      await publicKeyFormApi!.validate();
      await apiClient.request(
        "/configs/createSourcePublicKey",
        "POST",
        undefined,
        publicKeyFormApi!.getValues()
      );

      crudApi?.refresh();
      setCreatePublicKey(false);
    } catch (e) {}
  };

  const handleCreatePublicKeyButtonClick = (a: any, rows: any) => {
    setCreatePublicKey(true);
  };

  const handleShowPublicKeyButtonClick = (a: any, rows: any) => {
    if (!rows || rows.length == 0) {
      Toast.info("请选择一条数据");
      return;
    }
    if (rows.length > 1) {
      Toast.info("只能选择一条数据");
      return;
    }
    setShowPublicKeyModal(true);
    let row = rows[0];
    setPublicKeyContent("渠道编码："+row.ext1+"\nuid："+row.ext2+"\n公钥："+row.value+"\n私钥："+row.ext3);
  };

  const actions: CrudAction[] = [];
  const createPublicKeyAction: CrudAction = {
    name: "生成渠道对接secret",
    action: handleCreatePublicKeyButtonClick,
  };

  const viewPublicKeyAction: CrudAction = {
    name: "查看渠道对接secret",
    action: handleShowPublicKeyButtonClick,
  };
  actions.push(createPublicKeyAction);
  actions.push(viewPublicKeyAction);

  return (
    <>
      <Modal
        icon={
          <IconModalStroked size={"extra-large"} style={{ color: "blue" }} />
        }
        style={{ width: 400, height: 300 }}
        title="生成渠道对接secret"
        visible={createPublicKey}
        okText="确定"
        onOk={handlePublicModalClick}
        onCancel={() => setCreatePublicKey(false)}

      >
        <Form getFormApi={(formApi) => setPublicKeyFormApi(formApi)}>
          <Form.Input field="code" label="渠道编码" rules={[{required: true, message: "请填写"}]} />
        </Form>
       
      </Modal>
      <Modal
        icon={
          <IconModalStroked size={"extra-large"} style={{ color: "blue" }} />
        }
        style={{ width: 800, height: 500 }}
        title="查看渠道对接secret"
        hasCancel={false}

        visible={showPublicKeyModal}
        onOk={() => setShowPublicKeyModal(false)}
        onCancel={() => setShowPublicKeyModal(false)}
      >
        <Form>
          <Form.TextArea initValue={publicKeyContent} rows={15} field="content"  label="渠道对接信息" />
        </Form>
      </Modal>
      <Tabs type="line" style={{ margin: 10 }}>
        <TabPane
          tab={
            <span>
              <IconSetting />
              常用参数
            </span>
          }
          itemKey="1"
        >
          <Crud
            canUpdate={true}
            canCreate={true}
            name="常用参数"
            params={{ client: "common" }}
            entityKey="configs"
            pageSize={50}
            cols={cols}
          />
        </TabPane>
        <TabPane
          tab={
            <span>
              <IconFixedStroked />
              系统参数
            </span>
          }
          itemKey="2"
        >
          <Crud
            getCrudApi={(crudApiT) => {
              setCrudApi(crudApiT);
            }}
            actions={actions}
            canUpdate={true}
            canCreate={true}
            select={true}
            name="系统参数"
            params={{ client: "system" }}
            entityKey="configs"
            pageSize={50}
            cols={colSyss}
          />
        </TabPane>
      </Tabs>
    </>
  );
}
